import {forwardRef, ReactNode} from 'react';
import {Typography} from '../Typography';
import {PageTitleContainer} from './PageTitleContainer';

export type PageTitleProps = {
    BreadcrumbsComponent?: ReactNode;
    title?: ReactNode;
};

export const PageTitle = forwardRef<HTMLDivElement, PageTitleProps>((props, ref) => (
    <PageTitleContainer ref={ref}>
        {props.BreadcrumbsComponent}
        {props.title && (
            <Typography
                component={'h1'}
                variant={'h1'}
            >
                {props.title}
            </Typography>
        )}
    </PageTitleContainer>
));

PageTitle.displayName = 'PageTitle';
